import React from 'react';
import { Container, Typography, Box, Divider, Paper, List, ListItem, ListItemText, Link } from '@mui/material';

const PrivacyPolicy = () => {
  // Update mo na lang itong date kung kailan niyo i-publish
  const effectiveDate = "March 24, 2026"; 

  return (
    <Box sx={{ backgroundColor: '#f5f5f5', py: { xs: 4, md: 8 }, minHeight: '100vh' }}>
      <Container maxWidth="md">
        <Paper elevation={4} sx={{ p: { xs: 3, md: 6 }, borderRadius: 3, border: '1px solid #e0e0e0' }}>
          
          
          <Box sx={{ mb: 5, textAlign: 'center' }}>
            <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 800, letterSpacing: '-0.5px', color: '#111' }}>
              Privacy Policy
            </Typography>
            <Typography variant="h6" sx={{ color: '#666', mb: 1, fontWeight: 400 }}>
              Leon Gallery | leon-gallery.com
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Effective Date: <strong>{effectiveDate}</strong>
            </Typography>
          </Box>

          <Divider sx={{ mb: 5 }} />

          <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.8 }}>
            Leon Gallery (<strong>we</strong>) <strong>values</strong> your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, and safeguard your data when you visit <strong>leon-gallery.com</strong> or interact with our services.
          </Typography>

          
          <Typography variant="h5" sx={{ mt: 5, mb: 2, fontWeight: 700 }}>1. Information We Collect</Typography>
          <Box sx={{ pl: 1 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#1976d2' }}>a. Personal Information</Typography>
            <Typography variant="body1" paragraph>
              Full name, email address, contact number, shipping and billing address (if applicable), and any information you provide through contact forms.
            </Typography>
            
            <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#1976d2' }}>b. Non-Personal Information</Typography>
            <Typography variant="body1" paragraph>
              IP address, browser type, device information, pages visited, and time spent on the Website.
            </Typography>

            <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#1976d2' }}>c. Transaction Information (if applicable)</Typography>
            <Typography variant="body1" paragraph>
              Purchase details and payment confirmation (processed via secure third-party providers).
            </Typography>
          </Box>

          
          <Typography variant="h5" sx={{ mt: 5, mb: 2, fontWeight: 700 }}>2. How We Use Your Information</Typography>
          <Typography variant="body1" paragraph>We utilize your data to:</Typography>
          <List sx={{ pl: 2 }}>
            <ListItem disableGutters><ListItemText primary="• Respond to inquiries and messages." /></ListItem>
            <ListItem disableGutters><ListItemText primary="• Process orders and deliver artworks (if applicable)." /></ListItem>
            <ListItem disableGutters><ListItemText primary="• Send updates about exhibitions, events, and promotions (strictly with your consent)." /></ListItem>
            <ListItem disableGutters><ListItemText primary="• Improve our Website performance and overall user experience." /></ListItem>
            <ListItem disableGutters><ListItemText primary="• Comply with legal obligations under applicable Philippine laws." /></ListItem>
          </List>

          
          <Box sx={{ my: 5, p: 3, borderLeft: '6px solid #1a1a1a', backgroundColor: '#f8f9fa' }}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 700 }}>3. Legal Basis (Philippines - Data Privacy Act of 2012)</Typography>
            <Typography variant="body1">
              We process your personal data in accordance with the <strong>Data Privacy Act of 2012</strong>. By using our Website, you consent to the collection and use of your information as described in this policy.
            </Typography>
          </Box>

          
          <Typography variant="h5" sx={{ mt: 5, mb: 2, fontWeight: 700 }}>4. Sharing of Information</Typography>
          <Typography variant="body1" paragraph>
            We do not sell your personal data. We may share your information with service providers (e.g., payment processors, delivery services), IT and website hosting providers, and authorities when required by law. All third parties are required to protect your data in accordance with applicable laws.
          </Typography>

          
          <Typography variant="h5" sx={{ mt: 5, mb: 2, fontWeight: 700 }}>5. Cookies and Tracking</Typography>
          <Typography variant="body1" paragraph>
            Our Website may use cookies to enhance user experience, analyze traffic, and remember preferences. You can disable cookies in your browser settings, but some features of the Website may not function properly.
          </Typography>

          
          <Typography variant="h5" sx={{ mt: 5, mb: 2, fontWeight: 700 }}>6. Data Security</Typography>
          <Typography variant="body1" paragraph>
            We implement reasonable technical and organizational measures to protect your personal data. However, please note that no online system is completely secure.
          </Typography>

          
          <Typography variant="h5" sx={{ mt: 5, mb: 2, fontWeight: 700 }}>7. Your Rights</Typography>
          <Typography variant="body1" paragraph>
            Under the Data Privacy Act, you have the right to access your personal data, request correction or deletion, withdraw consent, or file a complaint with the <strong>National Privacy Commission (NPC)</strong>.
          </Typography>

          
          <Typography variant="h5" sx={{ mt: 5, mb: 2, fontWeight: 700 }}>8. Data Retention</Typography>
          <Typography variant="body1" paragraph>
            We retain your personal information only as long as necessary for the purposes stated in this policy or as required by law.
          </Typography>

          
          <Typography variant="h5" sx={{ mt: 5, mb: 2, fontWeight: 700 }}>9. Third-Party Links</Typography>
          <Typography variant="body1" paragraph>
            Our Website may contain links to external websites. We are not responsible for their privacy practices or content.
          </Typography>

          
          <Typography variant="h5" sx={{ mt: 5, mb: 2, fontWeight: 700 }}>10. Changes to This Policy</Typography>
          <Typography variant="body1" paragraph>
            We may update this Privacy Policy from time to time. Changes will be posted on this page with an updated effective date.
          </Typography>

          <Divider sx={{ my: 5 }} />

          
          <Box sx={{ backgroundColor: '#fff', p: 4, borderRadius: 2, border: '1px solid #eee', textAlign: 'center' }}>
            <Typography variant="h5" sx={{ mb: 2, fontWeight: 700 }}>11. Contact Information</Typography>
            <Typography variant="body1">
              <strong>Leon Gallery</strong><br />
              Website: <Link href="https://leon-gallery.com" sx={{ fontWeight: 600 }}>leon-gallery.com</Link><br />
              Email: <strong>info@leon-gallery.com</strong><br />
              Address: <strong>G/F Eurovilla 1, Legazpi corner Rufino Sts., Legazpi Village, Makati City</strong>
            </Typography>
          </Box>

          
          <Box sx={{ mt: 6, p: 3, border: '1px dashed #bbb', borderRadius: 2, backgroundColor: '#fff9e6' }}>
            <Typography variant="body2" sx={{ fontStyle: 'italic', color: '#555' }}>
              <strong>Note:</strong> This Privacy Policy is tailored for a standard gallery website. If <strong>leon-gallery.com</strong> includes features such as user accounts, online auctions, or payment systems, additional legal clauses may be recommended as these features evolve.
            </Typography>
          </Box>

        </Paper>
      </Container>
    </Box>
  );
};

export default PrivacyPolicy;